import React from 'react';
import {
  Table,
} from 'react-bootstrap';


const JobInvoiceInboxLegend = (props) => {
  return (
    <React.Fragment>
      <Table>
        <thead>
          <tr>
            <th>Color</th>
            <th>Description</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <span className="selected-icon">&nbsp;</span>
            </td>
            <td>Selected Job</td>
          </tr>
          <tr>
            <td>
              <span className="ready-to-invoice-icon">&nbsp;</span>
            </td>
            <td>Ready to be Invoiced</td>
          </tr>
          <tr>
            <td>
              <span className="in-sage-icon">&nbsp;</span>
            </td>
            <td>In Sage</td>
          </tr>
          <tr>
            <td>
              <span className="removed-from-sage-icon">&nbsp;</span>
            </td>
            <td>Removed from Sage</td>
          </tr>
        </tbody>
      </Table>
    </React.Fragment>
  );
};

export default JobInvoiceInboxLegend;
